var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoFood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s5eofcko5a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.62 45.23c0 21.71-17.6 39.31-39.31 39.31S5 66.94 5 45.23 22.6 5.92 44.31 5.92s39.31 17.6 39.31 39.31z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.624 47.795c0 20.295-16.452 36.747-36.747 36.747-20.294 0-36.746-16.452-36.746-36.747 0-20.294 16.452-36.746 36.746-36.746 20.295 0 36.747 16.452 36.747 36.746z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.396 13.534a2.868 2.868 0 0 0-2.625-1.714h-5.916a2.871 2.871 0 0 0-2.868 2.868 2.87 2.87 0 0 0 2.868 2.867h4.044l2.196 4.997.09-.07a15.842 15.842 0 0 1 4.894-2.6l.094-.03-2.777-6.318z",
    fill: "#DFEBFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.772 60.746H31.52l-7.036 7.035h20.013l-.724-7.035z",
    fill: "#BC7C63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.817 61.889-.065.09.053.098a37.715 37.715 0 0 0 3.282 5.02 1.604 1.604 0 0 0 1.268.623c.42 0 .826-.166 1.125-.466l6.509-6.508h-9.95c-.877 0-1.708.427-2.222 1.143z",
    fill: "#AB6B51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.612 60.924-1.121-10.899-10.9 10.9h12.021zM39.674 44.061l-.275-.09C26.424 39.756 14.4 46.579 10.76 57.789c-.53 1.635.699 3.312 2.424 3.312h9.45l17.039-17.039z",
    fill: "#FFBD86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.093 57.789c2.326-7.164 8.076-12.535 15.31-14.38-12.195-2.937-23.19 3.747-26.642 14.38-.53 1.634.699 3.311 2.424 3.311h9.45l.443-.443a2.527 2.527 0 0 1-.985-2.868z",
    fill: "#F6A96C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.025 72.917-.565-5.49H24.838l-4.093 4.093a1.598 1.598 0 0 0 .157 2.393 37.84 37.84 0 0 0 2.063 1.489l.045.03H47.42v-.354a2.4 2.4 0 0 1-2.394-2.16z",
    fill: "#FFBD86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.105 75.305v-7.877h-.267l-4.093 4.092a1.598 1.598 0 0 0 .157 2.393 37.84 37.84 0 0 0 2.064 1.489l.044.03h2.102c-.002-.043-.007-.084-.007-.127z",
    fill: "#F6A96C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.852 34.963.727 7.067 7.067-7.067h-7.794z",
    fill: "#0193FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.427 34.963 42.398 49.992l2.362 22.951a2.666 2.666 0 0 0 2.659 2.4h17.545l.023-.016a37.883 37.883 0 0 0 4.278-3.343l.025-.023 3.808-36.998H57.427z",
    fill: "#23A8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.82 42.57-7.422 7.422 2.362 22.952a2.666 2.666 0 0 0 2.659 2.399h5.774L49.82 42.57z",
    fill: "#0193FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.234 20.202a16.005 16.005 0 0 0-6.26-1.265c-3.333 0-6.531 1.01-9.249 2.92a16.09 16.09 0 0 0-5.816 7.476l-.046.12h12.293l9.2-9.2-.122-.051z",
    fill: "#DFEBFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.508 21.857a15.983 15.983 0 0 1 5.853-2.559 16.1 16.1 0 0 0-3.386-.36c-3.334 0-6.532 1.009-9.25 2.919a16.09 16.09 0 0 0-5.816 7.476l-.046.12h6.783l.045-.12a16.092 16.092 0 0 1 5.817-7.476z",
    fill: "#B1DBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.04 29.333a16.041 16.041 0 0 0-3.431-5.424l-.063-.065-5.61 5.61h9.15l-.045-.12z",
    fill: "#DFEBFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.558 31.59v1.24a2.314 2.314 0 0 0 2.311 2.311h8.6l5.864-5.864H39.87a2.314 2.314 0 0 0-2.311 2.312z",
    fill: "#FEE55A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.58 32.873v-1.327c0-1.015.616-1.889 1.494-2.269h-8.205a2.314 2.314 0 0 0-2.311 2.312v1.24a2.314 2.314 0 0 0 2.311 2.312h8.205a2.475 2.475 0 0 1-1.493-2.268z",
    fill: "#FFD301"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.081 29.277H63.114l-5.864 5.864h16.831a2.314 2.314 0 0 0 2.312-2.311v-1.24a2.314 2.314 0 0 0-2.312-2.313z",
    fill: "#FEE55A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.113 12.887c-17.183-17.183-45.043-17.183-62.226 0s-17.183 45.042 0 62.226c17.183 17.183 45.043 17.183 62.226 0 17.183-17.184 17.183-45.043 0-62.226zM16.355 67.13a1.42 1.42 0 0 1-2.128-.14C2.806 52.237 3.863 30.944 17.403 17.404c13.54-13.54 34.834-14.598 49.587-3.176a1.42 1.42 0 0 1 .14 2.128L16.355 67.129zm4.655 6.644a1.42 1.42 0 0 1-.14-2.128L71.646 20.87a1.42 1.42 0 0 1 2.128.14c11.422 14.753 10.365 36.046-3.176 49.586-13.54 13.54-34.833 14.597-49.587 3.176z",
    fill: "#FF4545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.117 75.114a44.14 44.14 0 0 1-6.092-7.61 1.418 1.418 0 0 1-.798-.514c-11.14-14.39-10.407-35 2.2-48.57a44.27 44.27 0 0 1 4.69-5.532A43.818 43.818 0 0 1 48.116.194C35.525-.982 22.526 3.249 12.887 12.888c-17.183 17.183-17.183 45.042 0 62.226 9.64 9.64 22.639 13.87 35.228 12.694a43.821 43.821 0 0 1-26.998-12.695z",
    fill: "#FF4756"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "s5eofcko5a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h88v88H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFood);
export default __webpack_public_path__ + "static/media/no-food.73f010ea9faeeef7ec0a3c79a93fd0a4.svg";
export { ForwardRef as ReactComponent };